import KBSearchListItem from './KbSearchListItem';

export default KBSearchListItem;
